__turbopack_context__.v({
  "articlesGrid": "NewsView-module__4vaLcG__articlesGrid",
  "articlesSection": "NewsView-module__4vaLcG__articlesSection",
  "breadcrumb": "NewsView-module__4vaLcG__breadcrumb",
  "breadcrumbCurrent": "NewsView-module__4vaLcG__breadcrumbCurrent",
  "breadcrumbLink": "NewsView-module__4vaLcG__breadcrumbLink",
  "breadcrumbSeparator": "NewsView-module__4vaLcG__breadcrumbSeparator",
  "cardsGrid": "NewsView-module__4vaLcG__cardsGrid",
  "cardsSection": "NewsView-module__4vaLcG__cardsSection",
  "clearFiltersButton": "NewsView-module__4vaLcG__clearFiltersButton",
  "exploreRootsButton": "NewsView-module__4vaLcG__exploreRootsButton",
  "exploreRootsWrap": "NewsView-module__4vaLcG__exploreRootsWrap",
  "gradientOrb1": "NewsView-module__4vaLcG__gradientOrb1",
  "gradientOrb2": "NewsView-module__4vaLcG__gradientOrb2",
  "hero": "NewsView-module__4vaLcG__hero",
  "heroBackground": "NewsView-module__4vaLcG__heroBackground",
  "heroContent": "NewsView-module__4vaLcG__heroContent",
  "heroSubtitle": "NewsView-module__4vaLcG__heroSubtitle",
  "heroTitle": "NewsView-module__4vaLcG__heroTitle",
  "main": "NewsView-module__4vaLcG__main",
  "noResults": "NewsView-module__4vaLcG__noResults",
  "noResultsIcon": "NewsView-module__4vaLcG__noResultsIcon",
  "noResultsText": "NewsView-module__4vaLcG__noResultsText",
  "noResultsTitle": "NewsView-module__4vaLcG__noResultsTitle",
  "paginationLtrShell": "NewsView-module__4vaLcG__paginationLtrShell",
});
